/** @flow */

import { object, string } from "yup";
import { stringExists, poBox } from "./helpers";
import { isEurope } from "../../countryHelper";

const COUNTRY_CODE = "$countryCode";
const PLEASE_SELECT_AN_OPTION = "Please select an option from the list";

export const addressFields = {
  street_address: string()
    .when(COUNTRY_CODE, { is: "USA", then: poBox, otherwise: stringExists })
    .when(COUNTRY_CODE, (countryCode, schema) => {
      if (isEurope(countryCode)) {
        return schema.min(
          4,
          "Please enter a valid street address (at least 4 characters)"
        );
      }
      return schema;
    }),
  extended_address: string(),
  locality: stringExists.when(COUNTRY_CODE, (countryCode, schema) => {
    if (isEurope(countryCode)) {
      return schema.min(2, "Please enter a valid city (at least 2 characters)");
    }
    return schema;
  }),
  postal_code: string().when(COUNTRY_CODE, {
    is: "USA",
    then: stringExists.length(5, "Please enter a 5-digit postal code"),
    otherwise: stringExists
  })
};

export const addressFieldsForBusiness = object().shape({
  ...addressFields,
  region: string()
    .when(COUNTRY_CODE, {
      is: "AUS",
      then: string()
        .ensure()
        .required(PLEASE_SELECT_AN_OPTION)
    })
    .when(COUNTRY_CODE, {
      is: "NZL",
      then: stringExists
    })
    .when(COUNTRY_CODE, {
      is: "MYS",
      then: stringExists
    })
    .when(COUNTRY_CODE, {
      is: "SGP",
      then: stringExists
    })
    .when(COUNTRY_CODE, {
      is: "HKG",
      then: stringExists
    })
    .when(COUNTRY_CODE, {
      is: "USA",
      then: string().required(PLEASE_SELECT_AN_OPTION)
    })
    .when(COUNTRY_CODE, {
      is: "BRA",
      then: stringExists
    })
});

export const addressFieldsForContact = object().shape({
  ...addressFields,
  region: string().when(COUNTRY_CODE, {
    is: "USA",
    then: string().required(PLEASE_SELECT_AN_OPTION),
    otherwise: stringExists
  }),
  country: string().when(COUNTRY_CODE, {
    is: "USA",
    then: string()
      .ensure()
      .matches(/USA/, "Only US addresses are valid for contacts"),
    otherwise: stringExists
  })
});
